module.exports = __webpack_public_path__ + "img/ugyot_yes.9ca821cc.png";